import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../../actions/consumer.actions";
import { VendorActions } from "../../actions/vendor.actions";
import { ActionItemsState } from "../../models/shared/action-items-state";

const initialState: ActionItemsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.actionItems.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerActions.actionItems.getSuccess, (state, action) => _.omit(action, "type")),
	on(ConsumerActions.actionItems.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	})),
	on(VendorActions.actionItems.getApi, (state) => ({ ...state, loading: true })),
	on(VendorActions.actionItems.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(VendorActions.actionItems.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function actionItemsReducer(
	state: ActionItemsState | undefined,
	action: Action
): ActionItemsState {
	return reducer(state, action);
}
